import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import PaxSearchPanel from '../PaxSearchPanel';
import FromToAutocomplete from '../FromToAutocomplete';

const FlightsSearchLayout = ({
  layoutType,
  components = {},
  airSectionRow = [],
  renderSection = () => {},
  addFlightSection,
  removeFlightSection,
  handleClick,
  showPassengers,
  handleClose,
  setFlightClass,
  flightClass,
  executeSearch,
  hasErrorMessage,
  setAirSectionRow,
  searchPax,
  setSearchPax,
}) => {
  const [paxError, setPaxError] = useState(null);

  // Panel de pasajeros
  const paxSearchPanel = (
    <PaxSearchPanel
      handleClick={handleClick}
      showPassengers={showPassengers}
      handleClose={handleClose}
      setSearchPax={setSearchPax}
      searchPax={searchPax}
      setFlightClass={setFlightClass}
      flightClass={flightClass}
      executeSearch={executeSearch}
      setPaxError={setPaxError}
      paxError={paxError}
    />
  );

  // Layout estándar (OneWay / RoundTrip)
  const standardLayoutJSX = (
    <Grid item xs={12}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} md={components?.Left?.md || 8}>
          <FromToAutocomplete
            origin={airSectionRow[0]?.origin}
            destination={airSectionRow[0]?.destination}
            flightOrigin={value => {
              const newAirSection = [...airSectionRow];
              newAirSection[0].origin = value;
              if (newAirSection[1]) {
                newAirSection[1].destination = value;
              }
              setAirSectionRow(newAirSection);
            }}
            flightDestination={value => {
              const newAirSection = [...airSectionRow];
              newAirSection[0].destination = value;
              if (newAirSection[1]) {
                newAirSection[1].origin = value;
              }
              setAirSectionRow(newAirSection);
            }}
          />
        </Grid>
        {components.Middle?.component && (
          <Grid item xs={12} md={components.Middle.md || 4}>
            {components.Middle.component}
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={2}>
          {paxSearchPanel}
        </Grid>
      </Grid>
    </Grid>
  );

  // Layout multidestino
  const multidestinoLayoutJSX = (
    <Grid
      container
      direction="row"
      wrap="wrap"
      alignItems="flex-start"
      columnSpacing={2}
      id="MD-GRID-LAYOUT"
    >
      <Grid item xs={12} md={10}>
        {airSectionRow.map((section, i) =>
          renderSection(section, i, addFlightSection, removeFlightSection)
        )}
      </Grid>
      <Grid item xs={12} md={2}>
        <Grid
          item
          xs={12}
          sx={{
            display: { xs: 'none', md: 'block' },
            height: '15px',
            mb: '15px',
          }}
        />
        {paxSearchPanel}
      </Grid>
    </Grid>
  );

  // Map de layouts según tipo de viaje
  const layoutMap = {
    oneway: standardLayoutJSX,
    roundtrip: standardLayoutJSX,
    multidestino: multidestinoLayoutJSX,
  };

  return (
    <Grid container>
      {layoutMap[layoutType] || null}
      {(paxError || hasErrorMessage) && (
        <Grid item xs={12}>
          {paxError && (
            <Typography variant="subtitle2" color="error">
              {paxError}
            </Typography>
          )}
          {hasErrorMessage && (
            <Typography variant="subtitle2" color="error">
              {hasErrorMessage}
            </Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default FlightsSearchLayout;
